<template>
  <div class="report-detail">
    <el-form
      ref="eaParams"
      :model="eaParams"
      :rules="eaRules"
      label-width="150px"
    >
      <!--<el-form-item label="编号：" prop="code">
        <el-input v-model="eaParams.code" type="text" :disabled="true" placeholder="0-100个字符" class="form-element" />
      </el-form-item>-->
      <el-form-item label="是否完工：" prop="is_completed">
        <el-radio-group
          v-model="eaParams.is_completed"
          class="form-item-width"
          @change="onIsCompletedChange"
        >
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="eaParams.is_completed === 1"
        label="完工日期："
        prop="finished_at"
      >
        <el-date-picker
          v-model="eaParams.completed_at"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择"
          class="form-item-width"
        />
      </el-form-item>
      <el-form-item label="品牌：" prop="brand_id">
        <el-select
          v-model="eaParams.brand_id"
          placeholder="请选择"
          filterable
          clearable
          class="form-item-width"
          @change="syncShops"
        >
          <el-option
            v-for="(v, k) in brandsList"
            :key="k"
            :value="v.id"
            :label="v.brand_en"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="城市：" prop="brand_id">
        <el-select
          v-model="eaParams.city_id"
          placeholder="请选择"
          filterable
          clearable
          class="form-item-width"
          @change="syncData"
        >
          <el-option
            v-for="(v, k) in cityList"
            :key="k"
            :value="v.id"
            :label="v.city_cn"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商场：" prop="market_id">
        <el-select
          v-model="eaParams.market_id"
          placeholder="支持输入"
          filterable
          class="form-item-width"
          @change="syncShops"
        >
          <el-option
            v-for="(v, k) in markets"
            :key="k"
            :value="v.id"
            :label="v.market_cn"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="店铺：" prop="store_id">
        <el-select
          v-model="eaParams.store_id"
          placeholder="请选择"
          filterable
          class="form-item-width"
          @change="changeStore"
        >
          <el-option
            v-for="v in storeList"
            :key="v.id"
            :value="v.id"
            :label="v.name_cn"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="公司：" prop="company_id">
        <el-select
          v-model="eaParams.company_id"
          placeholder="请选择"
          filterable
          class="form-item-width"
          @change="changeStore"
        >
          <el-option
            v-for="v in companies"
            :key="v.id"
            :value="v.id"
            :label="v.company_en"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="维修类型：" prop="ma_type_cn">
        <el-radio-group
          v-model="eaParams.ma_type_cn"
          class="form-item-width"
          @change="changeRepairType"
        >
          <el-radio label="定期维保" />
          <el-radio label="紧急维修" />
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="eaParams.ma_type_cn === '定期维保'"
        label="预约时间："
        prop="appo_at"
      >
        <el-date-picker
          v-model="eaParams.appo_at"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item label="维修项目：" prop="ma_cate_id">
        <el-select
          v-model="eaParams.ma_cate_id"
          :allow-create="true"
          placeholder="支持输入"
          filterable
          clearable
          class="form-item-width"
          @change="syncShops"
        >
          <el-option
            v-for="(v, k) in projects"
            :key="k"
            :value="v.id"
            :label="v.cn_name ? v.cn_name : v.en_name"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="标题：" prop="report_title">
        <el-input
          v-model="eaParams.report_title"
          type="text"
          placeholder="0-100个字符"
          class="form-element"
          @input="refreshDate"
        />
      </el-form-item>
      <el-form-item label="签收单：" prop="receipts">
        <div class="receipts">
          <el-upload
            v-loading="receiptsLoading"
            class="upload-demo form-item-width"
            action="eric"
            :http-request="receiptsUpload"
            :on-remove="handleReceiptsRemove"
            :on-preview="handlePreview"
            :auto-upload="true"
            :multiple="true"
            :before-upload="beforeImgUpload"
            :file-list="eaParams.receipts"
            list-type="picture-card"
          >
            <i class="el-icon-plus" />
          </el-upload>
          <image-viewer
            v-if="showViewer"
            :z-index="zIndex"
            :initial-index="imageIndex"
            :on-close="closeViewer"
            :url-list="[previewSrc]"
          />
        </div>
      </el-form-item>
      <el-form-item label="选择模板" prop="model">
        <el-select
          v-model="eaParams.report_tid"
          placeholder="请选择"
          filterable
          class="form-element"
          @change="changeTemplate"
        >
          <el-option
            v-for="(v, k) in models"
            :key="k"
            :value="v.id"
            :label="v.title"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 9"
        label="报告时间："
        prop="report_times"
      >
        <template>
          <div
            v-for="(item, $index) in eaParams.report_times"
            :key="$index"
            style="overflow: hidden; margin-bottom: 10px;"
          >
            <el-date-picker
              v-model="item.date"
              type="date"
              style="width: 50%; float: left;"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @blur="evt => changeDate(evt, $index)"
            />
            <div style="text-align: right; float: left; width: 10%;">
              <i
                class="el-icon-plus"
                style="margin-left: 20px;cursor: pointer; font-size: 18px;"
                @click="addReportTime($index)"
              />
            </div>
            <div v-if="$index > 0" style="text-align: right; float: left;">
              <i
                class="el-icon-delete"
                style="margin-left: 20px;cursor: pointer; font-size: 18px; color: red;"
                @click="deleteReportTime($index)"
              />
            </div>
          </div>
        </template>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 9"
        label="设备表："
        prop="equipment_pic"
      >
        <div class="floor_plan">
          <!--<el-upload
            v-loading="floorLoading"
            class="upload-demo form-item-width"
            action="eric"
            :http-request="equipmentUpload"
            :on-remove="handleEquipmentRemove"
            :on-preview="handlePreview"
            :auto-upload="true"
            :limit="1"
            :multiple="false"
            :before-upload="beforeImgUpload"
            :file-list="equipment_pics"
            list-type="picture-card"
          >
            <i class="el-icon-plus" />
          </el-upload>-->
          <div
            v-for="(item, index) in equipment_pics"
            :key="index"
            class="floor_plan_img"
            style="float: left"
          >
            <img
              :src="item.url"
              alt="img"
              style="width: 100%; height: 100%;"
              @click="handlePreview(item)"
            />
          </div>
          <image-viewer
            v-if="showViewer"
            :z-index="zIndex"
            :initial-index="imageIndex"
            :on-close="closeViewer"
            :url-list="[previewSrc]"
            @transformImage="transformImage"
          />
        </div>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 9"
        label="布局图："
        prop="floorPlans"
      >
        <div class="floor_plan">
          <!--<el-upload
            v-loading="floorLoading"
            class="upload-demo form-item-width"
            action="eric"
            :http-request="floorPlanUpload"
            :on-remove="handleFloorPlanRemove"
            :on-preview="handlePreview"
            :auto-upload="true"
            :multiple="true"
            :before-upload="beforeImgUpload"
            :file-list="floorPlans"
            list-type="picture-card"
          >
            <i class="el-icon-plus" />
          </el-upload>-->
          <div
            v-for="(item, index) in floorPlans"
            :key="index"
            class="floor_plan_img"
            style="float: left"
          >
            <img
              :src="item.url"
              alt="img"
              style="width: 100%; height: 100%;"
              @click="handlePreview(item)"
            />
          </div>
          <image-viewer
            v-if="showViewer"
            :z-index="zIndex"
            :initial-index="imageIndex"
            :on-close="closeViewer"
            :url-list="[previewSrc]"
            @transformImage="transformImage"
          />
        </div>
      </el-form-item>
      <el-form-item
        v-if="
          eaParams.report_tid !== 10 &&
            eaParams.report_tid !== 11 &&
            eaParams.report_tid !== 12 &&
            eaParams.report_tid !== 13 &&
            eaParams.report_tid !== 5
        "
        label="明细"
        prop="details"
      >
        <!-- 明细 -->
        <div style="overflow: auto;">
          <div
            v-for="(row, $index) in eaParams.details"
            :key="$index"
            class="detail-items"
          >
            <div class="detail-items-top">
              <div class="detail-list">
                <el-upload
                  class="upload-container"
                  action="eric"
                  :http-request="detailUpload"
                  :auto-upload="true"
                  :before-upload="beforeImgUpload"
                  :show-file-list="false"
                  :data="{ index: $index, key: 'before' }"
                  list-type="picture-card"
                >
                  <div
                    v-if="eaParams.details[$index].before_thumb_url"
                    style="width: 100%; height: 100%;"
                    @click.stop
                  >
                    <my-image
                      :ref="`img_before_ref_${$index}`"
                      fit="fill"
                      style="width: 100%; height: 100%;"
                      :src="eaParams.details[$index].before_thumb_url"
                      :preview-src-list="[eaParams.details[$index].before_url]"
                      @transformImage="transformImage"
                    />
                    <div class="modal">
                      <i
                        class="el-icon-zoom-in"
                        @click="
                          previewImage(
                            `img_before_ref_${$index}`,
                            eaParams.details[$index].before_id,
                            'details'
                          )
                        "
                      />
                      <i
                        class="el-icon-delete"
                        @click="deleteImage($index, 'before')"
                      />
                    </div>
                  </div>
                  <!-- 根据不同的 状态显示不一样的按钮 -->
                  <i
                    v-else
                    :class="
                      eaParams.details[$index].beforeLoading
                        ? 'el-icon-loading'
                        : 'el-icon-plus'
                    "
                  />
                </el-upload>
              </div>
              <div
                v-if="[5, 6].indexOf(eaParams.report_tid) === -1"
                style="font-size: 20px; cursor: pointer;"
                @click="changePictureSort($index)"
              >
                <>
              </div>
              <div
                v-if="[5, 6].indexOf(eaParams.report_tid) === -1"
                class="detail-list"
              >
                <el-upload
                  class="upload-container"
                  action="eric"
                  :http-request="detailUpload"
                  :auto-upload="true"
                  :before-upload="beforeImgUpload"
                  :show-file-list="false"
                  :data="{ index: $index, key: 'after' }"
                  list-type="picture-card"
                >
                  <div
                    v-if="eaParams.details[$index].after_thumb_url"
                    style="width: 100%; height: 100%;"
                    @click.stop
                  >
                    <my-image
                      :ref="`img_after_ref_${$index}`"
                      fit="fill"
                      style="width: 100%; height: 100%;"
                      :src="eaParams.details[$index].after_thumb_url"
                      :preview-src-list="[eaParams.details[$index].after_url]"
                    />
                    <div class="modal">
                      <i
                        class="el-icon-zoom-in"
                        @click="
                          previewImage(
                            `img_after_ref_${$index}`,
                            eaParams.details[$index].after_id,
                            'details'
                          )
                        "
                      />
                      <i
                        class="el-icon-delete"
                        @click="deleteImage($index, 'after')"
                      />
                    </div>
                  </div>
                  <!-- 根据不同的 状态显示不一样的按钮 -->
                  <i
                    v-else
                    :class="
                      eaParams.details[$index].afterLoading
                        ? 'el-icon-loading'
                        : 'el-icon-plus'
                    "
                  />
                </el-upload>
              </div>
            </div>
            <div class="detail-info">
              <el-input
                  v-if="[1].indexOf(eaParams.report_tid) !== -1 && $index == 0"
                  v-model="eaParams.details[$index].description"
                  placeholder="请输入内容"
                  type="textarea"
                  :rows="3"
                  readonly
                  style="margin-right: 10px;"
                  :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              />
              <el-input
                  v-else-if="[1].indexOf(eaParams.report_tid) !== -1 && $index == 1"
                  v-model="eaParams.details[$index].description"
                  placeholder="请输入内容"
                  type="textarea"
                  :rows="3"
                  readonly
                  style="margin-right: 10px;"
                  :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              />
              <el-input
                  v-else-if="[1].indexOf(eaParams.report_tid) !== -1 && ($index > 1)"
                  v-model="eaParams.details[$index].description"
                  placeholder="请输入内容"
                  type="textarea"
                  :rows="3"
                  style="margin-right: 10px;"
                  :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              />
              <el-input
                v-else-if="[4, 5, 6].indexOf(eaParams.report_tid) !== -1"
                v-model="eaParams.details[$index].description"
                placeholder="请输入内容"
                type="textarea"
                :rows="3"
                style="margin-right: 10px;"
                :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              />
              <el-select
                v-else-if="
                  $index == 0 &&
                    [2, 3, 7, 9].indexOf(eaParams.report_tid) !== -1
                "
                v-model="eaParams.details[$index].description"
                disabled
                :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              >
                <el-option
                  v-for="list in descriptions"
                  :key="list.en"
                  :label="list.cn"
                  :value="list.cn"
                />
              </el-select>
              <el-select
                v-else
                v-model="eaParams.details[$index].description"
                :class="{
                  'is-save-error':
                    hasClick && !eaParams.details[$index].description
                }"
              >
                <el-option
                  v-for="list in descriptions"
                  :key="list.en"
                  :label="list.cn"
                  :value="list.cn"
                />
              </el-select>
              <div
                style="text-align: right;"
                v-if="
                  !(
                    $index == 0 &&
                    [2, 3, 7, 9].indexOf(eaParams.report_tid) !== -1
                  )
                "
              >
                <i
                  v-if="
                    $index > 0 &&
                      !(
                        $index == 0 &&
                        [2, 3, 7, 9].indexOf(eaParams.report_tid) !== -1
                      )
                  "
                  class="el-icon-top"
                  style="margin-left: 20px;cursor: pointer; font-size: 18px; color: #67C23A;"
                  @click="upDetails($index)"
                />
                <i
                  v-if="$index < eaParams.details.length - 1"
                  class="el-icon-bottom"
                  style="margin-left: 20px;cursor: pointer; font-size: 18px; color: #409EFF;"
                  @click="downDetails($index)"
                />
                <i
                  class="el-icon-delete"
                  style="margin-left: 20px;cursor: pointer; font-size: 18px; color: red;"
                  @click="deleteDetails($index)"
                />
              </div>
            </div>
          </div>
          <!-- 添加按钮 -->
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            style="width: 100%; margin: 14px auto 0 auto; display:block;"
            @click="addDetail"
            >添加一项</el-button
          >
        </div>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 11"
        label="明细"
        prop="details"
      >
        <!-- 明细 -->
        <div
          v-for="(item, index) in eaParams.elDetails"
          :key="index"
          style="overflow: auto;"
        >
          <div class="detail-items">
            <div>{{ index + 1 }}.{{ item.description }}</div>
            <div class="detail-items-top">
              <div class="receipts" style="width: 100%; height: 100%;">
                <el-upload
                  class="upload-demo form-item-width"
                  style="display: flex; min-height: 146px;"
                  action="eric"
                  :http-request="file => elUpload(file, index)"
                  :on-remove="
                    (file, fileList) => handleElRemove(file, fileList, index)
                  "
                  :on-preview="handlePreview"
                  :auto-upload="true"
                  :multiple="true"
                  :before-upload="beforeImgUpload"
                  :file-list="item.imageList"
                  list-type="picture-card"
                >
                  <i class="el-icon-plus" />
                </el-upload>
                <image-viewer
                  v-if="showViewer"
                  :z-index="zIndex"
                  :initial-index="imageIndex"
                  :on-close="closeViewer"
                  :url-list="[previewSrc]"
                  @transformImage="transformImage"
                />
              </div>
            </div>
            <div class="detail-info">
              <el-input
                v-model="item.remark"
                @input="refreshInputData"
                placeholder="请输入内容"
                type="textarea"
                :rows="3"
                style="margin-right: 10px;"
              />
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 12"
        label="明细"
        prop="details"
      >
        <!-- 明细 -->
        <div
          v-for="(item, index) in eaParams.twelveDetails"
          :key="index"
          style="overflow: auto;"
        >
          <div class="detail-items">
            <div>{{ index + 1 }}.{{ item.description }}</div>
            <div class="detail-items-top">
              <div class="receipts" style="width: 100%; height: 100%;">
                <el-upload
                  class="upload-demo form-item-width"
                  style="display: flex; min-height: 146px;"
                  action="eric"
                  :http-request="file => tweUpload(file, index)"
                  :on-remove="
                    (file, fileList) => handleTweRemove(file, fileList, index)
                  "
                  :on-preview="handlePreview"
                  :auto-upload="true"
                  :multiple="true"
                  :before-upload="beforeImgUpload"
                  :file-list="item.imageList"
                  list-type="picture-card"
                >
                  <i class="el-icon-plus" />
                </el-upload>
                <image-viewer
                  v-if="showViewer"
                  :z-index="zIndex"
                  :initial-index="imageIndex"
                  :on-close="closeViewer"
                  :url-list="[previewSrc]"
                  @transformImage="transformImage"
                />
              </div>
            </div>
            <div class="detail-info">
              <el-input
                v-model="item.remark"
                @input="refreshInputData"
                placeholder="请输入内容"
                type="textarea"
                :rows="3"
                style="margin-right: 10px;"
              />
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 13"
        label="明细"
        prop="details"
      >
        <div
          v-for="(item, index) in eaParams.thirteenDetails"
          :key="index"
          style="overflow: auto;"
        >
          <div class="detail-items">
            <div style="text-align: left; font-weight: bold">
              {{ index + 1 }}.{{ item.description }}
            </div>
            <div style="text-align: left; font-weight: bold">
              <div style="float: left; height: 30px; line-height: 30px;">图片类型:</div>
              <div style="float: left; height: 30px; line-height: 30px; margin-left: 10px; padding-top: 5px;">
                <van-radio-group v-model="eaParams.thirteenDetails[index].imageType" direction="horizontal">
                  <van-radio name="list" @click="clickRadio( index,'list')">列表</van-radio>
                  <van-radio name="before_after" @click="clickRadio(index,'before_after')">前后</van-radio>
                </van-radio-group>
              </div>
            </div>
            <div class="detail-items-top">
              <div class="receipts" style="width: 100%; height: 100%;">
                <el-upload
                  class="upload-demo form-item-width"
                  style="overflow: auto;"
                  action="eric"
                  :limit="2"
                  :http-request="file => thiUpload(file, index)"
                  :on-remove="
                    (file, fileList) => handleThiRemove(file, fileList, index)
                  "
                  :on-preview="handlePreview"
                  :auto-upload="true"
                  :multiple="true"
                  :before-upload="beforeImgUpload"
                  :file-list="item.imageList"
                  list-type="picture-card"
                >
                  <i class="el-icon-plus" />
                </el-upload>
                <image-viewer
                  v-if="showViewer"
                  :z-index="zIndex"
                  :initial-index="imageIndex"
                  :on-close="closeViewer"
                  :url-list="[previewSrc]"
                  @transformImage="transformImage"
                />
              </div>
            </div>
            <div style="overflow: hidden;">
              <div style="width: 200px; float: left;">
                <el-input
                  type="textarea"
                  autosize
                  @input="refreshInputData"
                  placeholder="请输入内容"
                  v-model="item.remark"
                />
              </div>
              <div style="width: 80px; float: left;">
                <i
                  class="el-icon-circle-plus-outline"
                  style="margin-left: 10px; margin-top: 10px;cursor: pointer; font-size: 28px; "
                  @click="addThirteenColumn(index + 1, item)"
                />
                <i
                  class="el-icon-delete"
                  style="margin-left: 10px; margin-top: 10px;cursor: pointer; font-size: 28px; color: red;"
                  @click="deleteThirteenColumn(index + 1, item)"
                />
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="eaParams.report_tid === 5"
        label="明细"
        prop="details"
      >
        <!-- 明细 -->
        <div style="overflow: auto;">
          <draggable
            v-model="eaParams.details"
            handle=".el-icon-sort"
            chosenClass="chosen"
            forceFallback="true"
            group="people"
            animation="1000"
            @start="onStart"
            @end="onEnd"
          >
            <transition-group>
              <div
                v-for="(row, $index) in eaParams.details"
                :key="$index"
                class="detail-items"
              >
                <div class="detail-list">
                  <el-upload
                    class="upload-demo form-item-width"
                    style="display: flex; min-height: 146px; overflow: hidden;"
                    action="eric"
                    :http-request="file => checkUpload(file, $index)"
                    :on-remove="
                      (file, fileList) =>
                        handleCheckRemove(file, fileList, $index)
                    "
                    :on-preview="handlePreview"
                    :auto-upload="true"
                    :multiple="true"
                    :before-upload="beforeImgUpload"
                    :file-list="row.imageList"
                    list-type="picture-card"
                  >
                    <i class="el-icon-plus" />
                  </el-upload>
                </div>
                <div class="detail-info">
                  <el-input
                    v-model="eaParams.details[$index].description"
                    placeholder="请输入内容"
                    type="textarea"
                    :rows="3"
                    style="margin-right: 10px;"
                    :class="{
                      'is-save-error':
                        hasClick && !eaParams.details[$index].description
                    }"
                  />
                  <div style=" text-align: right;">
                    <!--<i v-if="$index > 0" class="el-icon-top" style="margin-left: 20px;cursor: pointer; font-size: 18px; color: #67C23A;" @click="upDetails($index)" />-->
                    <!--<i v-if="$index < eaParams.details.length - 1" class="el-icon-bottom" style="margin-left: 20px;cursor: pointer; font-size: 18px; color: #409EFF;" @click="downDetails($index)" />-->
                    <i
                      class="el-icon-sort"
                      style="margin-left: 20px;cursor: pointer; font-size: 18px; color: #409EFF;"
                    />
                    <i
                      class="el-icon-delete"
                      style="margin-left: 20px;cursor: pointer; font-size: 18px; color: red;"
                      @click="deleteDetails($index)"
                    />
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <!-- 添加按钮 -->
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            style="width: 100%; margin: 14px auto 0 auto; display:block;"
            @click="addDetail"
          >添加一项</el-button
          >
        </div>
      </el-form-item>
      <div v-if="eaParams.report_tid === 10">
        <image-viewer
          v-if="showPictureView"
          :z-index="zIndex"
          :initial-index="imageIndex"
          :on-close="closeLookViewer"
          :url-list="[previewImageSrc]"
          @transformImage="transformImage"
        />
        <el-form-item class="report-add-before-after-image">
          <div style="overflow: auto;">
            <div
              v-for="(row, $index) in eaParams.specialDetails.beforeAfterData"
              :key="$index"
              class="detail-items"
            >
              <div style="width: 40%">
                <el-select
                  v-model="row.description"
                  filterable
                  clearable
                  placeholder="请选择检查问题"
                  :class="{ 'is-save-error': hasClick && !row.description }"
                  @change="updateData"
                >
                  <el-option
                    v-for="list in beforeAfterCategory"
                    :key="list"
                    :label="list"
                    :value="list"
                  />
                </el-select>
              </div>
              <div class="detail-items-top">
                <div class="detail-list">
                  <h3 style="color: red;">Before:</h3>
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="
                      file =>
                        specialBeforeAfterImageUpload(file, $index, 'before')
                    "
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'before' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="row.before_thumb_url"
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_before_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="row.before_thumb_url"
                        :preview-src-list="[row.before_url]"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_before_ref_${$index}`,
                              row.before_id,
                              'details'
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="
                            deleteSpecialBeforeAfterImage($index, 'before')
                          "
                        />
                      </div>
                    </div>
                    <i v-else class="el-icon-plus" />
                  </el-upload>
                </div>
                <div class="detail-list">
                  <h3 style="color: red;">After:</h3>
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="
                      file =>
                        specialBeforeAfterImageUpload(file, $index, 'after')
                    "
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'after' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="row.after_thumb_url"
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_after_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="row.after_thumb_url"
                        :preview-src-list="[row.after_url]"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_after_ref_${$index}`,
                              row.after_id,
                              'details',
                              row.after_url
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="
                            deleteSpecialBeforeAfterImage($index, 'after')
                          "
                        />
                      </div>
                    </div>
                    <i v-else class="el-icon-plus" />
                  </el-upload>
                </div>
                <div style=" text-align: right;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; "
                    @click="addColumn('beforeAfterData', $index)"
                  />
                  <i
                    v-if="$index > 0"
                    class="el-icon-delete"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; color: red;"
                    @click="deleteColumn('beforeAfterData', $index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="report-add-one-image">
          <div style="overflow: auto;">
            <div
              v-for="(row, $index) in eaParams.specialDetails.oneData"
              :key="$index"
              class="detail-items"
            >
              <div style="width: 40%">
                <el-select
                  v-model="row.description"
                  filterable
                  clearable
                  placeholder="请选择检查问题"
                  :class="{ 'is-save-error': hasClick && !row.description }"
                >
                  <el-option
                    v-for="list in onePicCategory"
                    :key="list"
                    :label="list"
                    :value="list"
                  />
                </el-select>
              </div>
              <div class="detail-items-top">
                <div class="detail-list">
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="file => specialOneImageUpload(file, $index)"
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'before' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="row.before_thumb_url"
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_before_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="row.before_thumb_url"
                        :preview-src-list="[row.before_url]"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_before_ref_${$index}`,
                              row.before_id,
                              'details',
                              row.before_url
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="deleteSpecialOneImageUpload($index)"
                        />
                      </div>
                    </div>
                    <i v-else class="el-icon-plus" />
                  </el-upload>
                </div>
                <div style=" text-align: right;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; "
                    @click="addColumn('oneData', $index)"
                  />
                  <i
                    v-if="$index > 0"
                    class="el-icon-delete"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; color: red;"
                    @click="deleteColumn('oneData', $index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="report-add-two-image">
          <div style="overflow: auto;">
            <div
              v-for="(row, $index) in eaParams.specialDetails.twoData"
              :key="$index"
              class="detail-items"
            >
              <div style="width: 40%">
                <el-select
                  v-model="row.description"
                  filterable
                  clearable
                  placeholder="请选择检查问题"
                  :class="{ 'is-save-error': hasClick && !row.description }"
                >
                  <el-option
                    v-for="list in twoPicCategory"
                    :key="list"
                    :label="list"
                    :value="list"
                  />
                </el-select>
              </div>
              <div class="detail-items-top">
                <div class="detail-list">
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="
                      file => specialTwoImageUpload(file, $index, 'before')
                    "
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'before' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="row.before_thumb_url"
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_before_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="row.before_thumb_url"
                        :preview-src-list="[row.before_url]"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_before_ref_${$index}`,
                              row.before_id,
                              'details',
                              row.before_url
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="deleteSpecialTwoImageUpload($index, 'before')"
                        />
                      </div>
                    </div>
                    <i v-else class="el-icon-plus" />
                  </el-upload>
                </div>
                <div class="detail-list">
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="
                      file => specialTwoImageUpload(file, $index, 'after')
                    "
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'after' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="row.after_thumb_url"
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_after_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="row.after_thumb_url"
                        :preview-src-list="[row.after_url]"
                        @transformImage="transformImage"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_after_ref_${$index}`,
                              row.after_id,
                              'details',
                              row.after_url
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="deleteSpecialTwoImageUpload($index, 'after')"
                        />
                      </div>
                    </div>
                    <i v-else class="el-icon-plus" />
                  </el-upload>
                </div>
                <div style=" text-align: right;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; "
                    @click="addColumn('twoData', $index)"
                  />
                  <i
                    v-if="$index > 0"
                    class="el-icon-delete"
                    style="margin-left: 20px; margin-top: 20px;cursor: pointer; font-size: 28px; color: red;"
                    @click="deleteColumn('twoData', $index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="问题及反馈描述" prop="details">
          <div style="overflow: auto;">
            <div
              v-for="(row, $index) in eaParams.specialDetails.questions"
              :key="$index"
              class="detail-items"
            >
              <div class="detail-items-top" style="float: left;">
                <div class="detail-list">
                  <el-upload
                    class="upload-container"
                    action="eric"
                    :http-request="file => questionImagesUpload(file, $index)"
                    :auto-upload="true"
                    :before-upload="beforeImgUpload"
                    :show-file-list="false"
                    :data="{ index: $index, key: 'before' }"
                    list-type="picture-card"
                  >
                    <div
                      v-if="
                        eaParams.specialDetails.questions[$index] &&
                          eaParams.specialDetails.questions[$index]
                            .before_thumb_url
                      "
                      style="width: 100%; height: 100%;"
                      @click.stop
                    >
                      <my-image
                        :ref="`img_before_ref_${$index}`"
                        fit="fill"
                        style="width: 100%; height: 100%;"
                        :src="
                          eaParams.specialDetails.questions[$index]
                            .before_thumb_url
                        "
                        :preview-src-list="[
                          eaParams.specialDetails.questions[$index].before_url
                        ]"
                      />
                      <div class="modal">
                        <i
                          class="el-icon-zoom-in"
                          @click="
                            lookImage(
                              `img_before_ref_${$index}`,
                              eaParams.specialDetails.questions[$index]
                                .before_id,
                              'details',
                              eaParams.specialDetails.questions[$index]
                                .before_url
                            )
                          "
                        />
                        <i
                          class="el-icon-delete"
                          @click="deleteQuestionImage($index)"
                        />
                      </div>
                    </div>
                    <!-- 根据不同的 状态显示不一样的按钮 -->
                    <i
                      v-else
                      :class="
                        eaParams.specialDetails.questions[$index].beforeLoading
                          ? 'el-icon-loading'
                          : 'el-icon-plus'
                      "
                    />
                  </el-upload>
                </div>
                <div style=" text-align: right;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-left: 20px;cursor: pointer; font-size: 28px;"
                    @click="addColumn('questions', $index)"
                  />
                  <i
                    v-if="$index > 0"
                    class="el-icon-delete"
                    style="margin-left: 20px;cursor: pointer; font-size: 28px; color: red;"
                    @click="deleteColumn('questions', $index)"
                  />
                </div>
              </div>
              <div class="detail-info" style="float: left">
                <el-input
                  v-model="eaParams.specialDetails.questions[$index].title"
                  placeholder="请输入问题"
                  type="text"
                  @input="updateData"
                  style="margin-right: 10px; display: block; width: 500px;"
                  :class="{
                    'is-save-error':
                      hasClick &&
                      !eaParams.specialDetails.questions[$index].title
                  }"
                />
              </div>
              <div>
                <el-input
                  v-model="eaParams.specialDetails.questions[$index].answer"
                  placeholder="请输入解决方案"
                  type="textarea"
                  @input="updateData"
                  :rows="3"
                  style="margin-right: 10px; display: block; width: 500px; margin-top: 10px;"
                  :class="{
                    'is-save-error':
                      hasClick &&
                      !eaParams.specialDetails.questions[$index].answer
                  }"
                />
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <!-- 点击按钮 -->
      <el-row
        style="margin: 60px 0;display: flex; align-items: center; justify-content: center;"
      >
        <el-button type="primary" @click="save(false)">保存</el-button>
        <el-button type="primary" @click="save(true)">预览</el-button>
        <el-button type="info" @click="back">返回</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
import myImage from "@/components/MyImage/index";
import ImageViewer from "@/components/MyImage/src/image-viewer";
import {
  createOrUpdateReport,
  getReportInfo,
  getReportTemplateList
} from "@/api/report";
import OSS from "ali-oss";
import {
  getBrandList,
  getCityList,
  getMarketList,
  getOssToken,
  getShopList
} from "../../../api/order";
import { getCompanyList, getFileRealPath } from "../../../api/util";
import { getOptions } from "@/api/ea";
import dayjs from "dayjs";
import { getCategories } from "../../../api/reimbursement";
import { createOrderAndReport } from "../../../api/report";
import draggable from "vuedraggable";

const ONE_PICTURE_CATEGORY = [
  "检查风管水管，空调阀门",
  "检查电机皮带",
  "机电维保：检查配电箱，螺丝紧固，灰尘清理",
  "机电维保：检查温控面板",
  "消防检查：检查烟感，消防喷淋，安全出口",
  "消防检查：检查灭火器"
];

const TWO_PICTURE_CATEGORY = [
  "检测店铺卖场机库房温度",
  "检测店铺进水管和回水管温度",
  "检测店铺出回风风速",
  "空调维保后留在店铺内观察设备运行是否正常",
  "商品保护"
];

const BEFORE_AFTER_CATEGORY = [
  "空调出风口百叶清洗",
  "空调过滤网清洗",
  "空调接水盘和接水盘排水口清洗",
  "空调表冷器清洗",
  "Y型过滤器清洗",
  "清洗分体空调外机",
  "排水管疏通"
];

const EaItemMap = [
  {
    name: "code",
    label: "编号",
    default: "",
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "company_id",
    label: "公司",
    default: 1,
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "brand_id",
    label: "品牌",
    default: 1,
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "job",
    label: "工作",
    default: "定期维护",
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "city",
    label: "城市",
    options: [],
    placeholder: "请选择城市",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "market_id",
    label: "商场",
    options: [],
    placeholder: "请选择商场",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "shop_id",
    label: "店铺",
    options: [],
    placeholder: "请选择店铺",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "store_id",
    label: "店铺",
    options: [],
    placeholder: "请选择店铺",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "job_type_id",
    label: "工作类型",
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "ma_cate_id",
    label: "维修项目",
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "complete_date",
    label: "完工日期",
    options: [],
    placeholder: "请选择日期",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "report_title",
    label: "标题",
    options: [],
    placeholder: "请填写标题",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "receipts",
    label: "签收单",
    default: [],
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ message: "必选项！", trigger: "blur" }]
  },
  {
    name: "model",
    label: "选择模板",
    options: [],
    default: 1,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "details",
    label: "明细",
    default: [{ description: "", beforeImg: "", afterImg: "" }],
    options: [],
    placeholder: "",
    disable: false,
    rules: [{ required: true, message: "必选项！", trigger: "blur" }]
  },
  {
    name: "specialDetails",
    label: "明细",
    default: {
      questions: [{}],
      oneData: [{}],
      twoData: [{}],
      beforeAfterData: [{}],
      cleanAirMachine: [{}]
    },
    options: []
  },
  {
    name: "elDetails",
    label: "明细",
    default: [
      { description: "检查所有电气接线点是否紧固", imageList: [], remark: "" },
      { description: "测试绝缘电阻值是否符合要求", imageList: [], remark: "" },
      { description: "测试电器电压是否正常", imageList: [], remark: "" },
      {
        description:
          "开关带负荷使用时有否发热（记录温度），带漏电保护的开关的实验按钮动作是否灵活可靠",
        imageList: [],
        remark: ""
      },
      {
        description: "各个开关（回路）标识是否清晰",
        imageList: [],
        remark: ""
      },
      {
        description: "测量三相负荷是否均匀，并重新整理箱内线路",
        imageList: [],
        remark: ""
      },
      {
        description:
          "已清除阻挡开关箱的物件，并对租户解释清除杂物阻挡开关箱的负面影响",
        imageList: [],
        remark: ""
      },
      { description: "已对箱内开关作除尘处理", imageList: [], remark: "" },
      { description: "检查散热风扇是否正常", imageList: [], remark: "" }
    ]
  },
  {
    name: "twelveDetails",
    label: "明细",
    default: [
      {
        description: "所有电气接线点是否紧固（包括开关接线、零线、地线）",
        imageList: [],
        remark: ""
      },
      {
        description: "所有开关及导线线径是否达标，线芯有否发热变色（均正常）",
        imageList: [],
        remark: ""
      },
      {
        description: "各个配电回路的绝缘电阻是否达标（均达标）",
        imageList: [],
        remark: ""
      },
      {
        description:
          "开关带负荷使用时有否发热（记录温度），带漏电保护的开关的实验按钮动作是否灵活可靠（均正常）",
        imageList: [],
        remark: ""
      },
      {
        description: "各个开关（回路）标识是否清晰（店铺无开关面板）",
        imageList: [],
        remark: ""
      },
      {
        description: "测量三相负荷是否均匀，如发现不均匀则进行调整（均匀）",
        imageList: [],
        remark: ""
      },
      {
        description: "确保没有杂物阻挡开关箱操作（无杂物）",
        imageList: [],
        remark: ""
      },
      { description: "所有开关除尘", imageList: [], remark: "" }
    ]
  },
  {
    name: "thirteenDetails",
    label: "明细",
    default: [
      { description: "室外幕墙-幕墙背景灯;", imageList: [], imageType: 'list' },
      { description: "室外幕墙-灯箱灯;", imageList: [], imageType: 'list'  },
      { description: "室外幕墙-橱窗灯;", imageList: [], imageType: 'list'  },
      { description: "室外幕墙-Logo灯;", imageList: [], imageType: 'list'  },
      { description: "室内幕墙-幕墙背景灯;", imageList: [], imageType: 'list'  },
      { description: "室内幕墙-灯箱灯;", imageList: [], imageType: 'list'  },
      { description: "室内幕墙-橱窗灯;", imageList: [], imageType: 'list'  },
      { description: "室内幕墙-Logo灯;", imageList: [], imageType: 'list'  },
      { description: "店铺内-灯具-天花灯;", imageList: [], imageType: 'list'  },
      { description: "店铺内-灯具-墙身柜灯;", imageList: [], imageType: 'list'  },
      { description: "店铺内-灯具-层板灯;", imageList: [], imageType: 'list'  },
      { description: "店铺内-灯具-海报背景灯;", imageList: [], imageType: 'list'  },
      { description: "电视屏-成衣区;", imageList: [], imageType: 'list'  },
      { description: "电视屏-珠宝区;", imageList: [], imageType: 'list'  },
      { description: "电视屏-楼梯区;", imageList: [], imageType: 'list'  },
      { description: "后勤-天花灯;", imageList: [], imageType: 'list'  },
      { description: "后勤-电箱用电设施;", imageList: [], imageType: 'list'  }
    ]
  }
];

export default {
  name: "NewReportPc",
  components: {
    myImage,
    ImageViewer,
    draggable,
  },
  props: {
    closeDetail: {
      type: Function,
      default: null
    },
    maItemId: {
      type: Number,
      default: 0
    },
    orderDetail: {},
    reportId: {
      type: Number,
      default: 0
    },
    orderId: {
      type: Number,
      default: 0
    },
    orderSupplierId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      commonDetails: {},
      showPictureView: false,
      previewImageSrc: "",
      receiptsLoading: false,
      floorLoading: false,
      descMap: {},
      models: [],
      eaParams: {
        ...EaItemMap.reduce((origin, item) => {
          origin[item.name] = item.default || "";
          return origin;
        }, {})
      },
      eaRules: {
        ...EaItemMap.reduce((origin, item) => {
          origin[item.name] = item.rules;
          return origin;
        }, {})
      },
      onePicCategory: ONE_PICTURE_CATEGORY,
      twoPicCategory: TWO_PICTURE_CATEGORY,
      beforeAfterCategory: BEFORE_AFTER_CATEGORY,
      detailInfo: {},
      shopMap: [],
      hasClick: false,
      currentFileId: 0,
      currentFileType: "",
      previewSrc: "",
      showViewer: false,
      zIndex: 2000,
      imageIndex: 0,
      floorPlans: [],
      equipment_pics: [],
      reportHasPic: false,
      oldShopId: null,
      brandsList: [],
      cityList: [],
      markets: [],
      storeList: [],
      companies: [],
      projects: []
    };
  },
  computed: {
    descriptions: function() {
      let ret = [];
      if (this.eaParams.report_tid === 3) {
        ret = this.descMap.temp3;
      } else if (this.eaParams.report_tid === 2) {
        ret = this.descMap.temp2;
      } else if (this.eaParams.report_tid === 7) {
        ret = this.descMap.temp7;
      } else if (this.eaParams.report_tid === 8) {
        ret = this.descMap.temp8;
      } else if (this.eaParams.report_tid === 13) {
        ret = this.descMap.temp10;
      } else {
        ret = this.descMap.temp1;
      }
      if (this.commonDetails.brand_id == 2 && this.eaParams.report_tid == 3) {
        ret.push({
          cn: "空调过滤网增加3M过滤网",
          en: "",
          picture: 2
        });
        ret.push({
          cn: "巴黎总部节能环保要求：空调温度重新设定",
          en: "",
          picture: 2
        });
      }
      return ret;
    }
  },
  async created() {
    const res = await getOptions();
    if (res.data.code > 0) {
      this.$message.error(res.data.msg);
      return;
    } else {
      this.descMap = res.data.data.descMap;
    }
    await this.initOptions();
    await getReportTemplateList().then(res => {
      if (res.data.data) {
        this.models = res.data.data;
      }
    });

    this.eaParams = {
      details: [{ description: "", beforeImg: "", afterImg: "" }],
      specialDetails: {
        questions: [{}],
        oneData: [{}],
        twoData: [{}],
        beforeAfterData: [{}],
        cleanAirMachine: [{}]
      }
    };
    this.eaParams.elDetails = [
      { description: "检查所有电气接线点是否紧固", imageList: [], remark: "" },
      { description: "测试绝缘电阻值是否符合要求", imageList: [], remark: "" },
      { description: "测试电器电压是否正常", imageList: [], remark: "" },
      {
        description:
          "开关带负荷使用时有否发热（记录温度），带漏电保护的开关的实验按钮动作是否灵活可靠",
        imageList: [],
        remark: ""
      },
      {
        description: "各个开关（回路）标识是否清晰",
        imageList: [],
        remark: ""
      },
      {
        description: "测量三相负荷是否均匀，并重新整理箱内线路",
        imageList: [],
        remark: ""
      },
      {
        description:
          "已清除阻挡开关箱的物件，并对租户解释清除杂物阻挡开关箱的负面影响",
        imageList: [],
        remark: ""
      },
      { description: "已对箱内开关作除尘处理", imageList: [], remark: "" },
      { description: "检查散热风扇是否正常", imageList: [], remark: "" }
    ];
    this.eaParams.twelveDetails = [
      {
        description: "所有电气接线点是否紧固（包括开关接线、零线、地线）",
        imageList: [],
        remark: ""
      },
      {
        description: "所有开关及导线线径是否达标，线芯有否发热变色（均正常）",
        imageList: [],
        remark: ""
      },
      {
        description: "各个配电回路的绝缘电阻是否达标（均达标）",
        imageList: [],
        remark: ""
      },
      {
        description:
          "开关带负荷使用时有否发热（记录温度），带漏电保护的开关的实验按钮动作是否灵活可靠（均正常）",
        imageList: [],
        remark: ""
      },
      {
        description: "各个开关（回路）标识是否清晰（店铺无开关面板）",
        imageList: [],
        remark: ""
      },
      {
        description: "测量三相负荷是否均匀，如发现不均匀则进行调整（均匀）",
        imageList: [],
        remark: ""
      },
      {
        description: "确保没有杂物阻挡开关箱操作（无杂物）",
        imageList: [],
        remark: ""
      },
      { description: "所有开关除尘", imageList: [], remark: "" }
    ];
    this.eaParams.thirteenDetails = [
      { description: "室外幕墙-幕墙背景灯;", imageList: [] , remark:"", imageType: 'list' },
      { description: "室外幕墙-灯箱灯;", imageList: [] , remark:"", imageType: 'list' },
      { description: "室外幕墙-橱窗灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "室外幕墙-Logo灯;", imageList: [] , remark:"" , imageType: 'list' },
      { description: "室内幕墙-幕墙背景灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "室内幕墙-灯箱灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "室内幕墙-橱窗灯;", imageList: [] , remark:"" , imageType: 'list' },
      { description: "室内幕墙-Logo灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "店铺内-灯具-天花灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "店铺内-灯具-墙身柜灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "店铺内-灯具-层板灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "店铺内-灯具-海报背景灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "电视屏-成衣区;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "电视屏-珠宝区;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "电视屏-楼梯区;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "后勤-天花灯;", imageList: [] , remark:"", imageType: 'list'  },
      { description: "后勤-电箱用电设施;", imageList: [] , remark:"", imageType: 'list'  }
    ];
    this.eaParams.is_completed = 0;
    this.eaParams.receipts = [];
    this.$forceUpdate();
  },
  methods: {
    addThirteenColumn(index, item) {
      this.eaParams.thirteenDetails.splice(index, 0, {
        description: item.description, imageList: [] , remark:'', imageType: 'list'
      })
      this.$forceUpdate()
    },
    deleteThirteenColumn(index, item) {
      this.eaParams.thirteenDetails.splice(index - 1, 1)
      this.$forceUpdate()
    },
    clickRadio(index, type) {
      this.eaParams.thirteenDetails[index].imageType = type
      this.$forceUpdate()
    },
    changeStore() {
      this.$forceUpdate();
    },
    onIsCompletedChange() {
      if (this.eaParams.is_completed === 0) {
        this.eaParams.complete_date = "";
      }
      this.$forceUpdate();
      console.log(this.eaParams);
    },
    changeRepairType() {
      this.eaParams.ma_cate_id = "";
      this.initProjects();
    },
    async initOptions() {
      await this.initCity();
      await this.initBrand();
      this.initProjects();
      this.initCompanies();
    },
    initProjects() {
      getCategories({
        p_type: this.eaParams.ma_type_cn === "紧急维修" ? "non_fix" : "fix"
      }).then(res => {
        if (res.data.data) {
          this.projects = res.data.data;
        }
      });
    },
    async initBrand() {
      await getBrandList().then(res => {
        if (res.data.data) {
          this.brandsList = res.data.data;
        }
      });
    },
    async syncData() {
      this.eaParams.store_id = "";
      this.eaParams.market_id = "";
      await this.initMarkets(this.eaParams.city_id);
      this.searchStore();
      this.$forceUpdate()
    },
    syncShops() {
      this.searchStore();
      this.$forceUpdate()
    },
    searchStore() {
      getShopList({
        brand_id: this.eaParams.brand_id,
        city_id: this.eaParams.city_id,
        market_id: this.eaParams.market_id
      }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          this.storeList = res.data.data;
        } else {
          let store_name = "";
          for (const item in this.cityList) {
            if (this.cityList[item].id == this.eaParams.city_id) {
              store_name = this.cityList[item].city_cn;
            }
          }
          for (const item in this.markets) {
            if (this.markets[item].id == this.eaParams.market_id) {
              store_name += this.markets[item].market_cn;
            }
          }
          this.storeList = [];
        }
      });
    },
    initMarkets(cityId) {
      getMarketList({ city_id: cityId }).then(res => {
        if (res.data.data) {
          this.markets = res.data.data;
        }
      });
    },
    initCompanies() {
      getCompanyList().then(res => {
        if (res.data.data) {
          this.companies = res.data.data;
        }
      });
    },
    async initCity() {
      await getCityList().then(res => {
        if (res.data.data) {
          this.cityList = res.data.data;
        }
      });
    },
    changePictureSort(index) {
      const detail = JSON.parse(JSON.stringify(this.eaParams.details[index]));
      this.eaParams.details[index].after_id = detail.before_id;
      this.eaParams.details[index].after_thumb_url = detail.before_thumb_url;
      this.eaParams.details[index].after_url = detail.before_url;
      this.eaParams.details[index].before_url = detail.after_url;
      this.eaParams.details[index].before_thumb_url = detail.after_thumb_url;
      this.eaParams.details[index].before_id = detail.after_id;
      this.$forceUpdate();
    },
    refreshInputData() {
      this.$forceUpdate();
    },
    updateData() {
      this.$forceUpdate();
    },
    refreshDate() {
      this.$forceUpdate();
    },
    changeTemplate() {
      if ([2, 3, 7, 9].indexOf(this.eaParams.report_tid) != -1) {
        this.eaParams.details[0].description = "商品防护";
      } else if ([1].indexOf(this.eaParams.report_tid) != -1) {
        if (typeof this.eaParams.details[0] !== 'undefined') {
          this.eaParams.details[0].description = "天花易燃物堆放检查";
          if (typeof this.eaParams.details[1] !== 'undefined') {
            this.eaParams.details[1].description = "天花线路安全隐患检查";
          } else {
            this.eaParams.details.splice(1, 0, {
              description: "天花线路安全隐患检查",
              before_thumb_url: '',
              before_url: '',
              after_thumb_url: '',
              after_url: '',
              before_id: '',
              after_id: '',
              remark: '',
            })
          }
        } else {
          this.eaParams.details = [{
            description: "天花易燃物堆放检查",
            before_thumb_url: '',
            before_url: '',
            after_thumb_url: '',
            after_url: '',
            before_id: '',
            after_id: '',
            remark: '',
          },{
            description: "天花线路安全隐患检查",
            before_thumb_url: '',
            before_url: '',
            after_thumb_url: '',
            after_url: '',
            before_id: '',
            after_id: '',
            remark: '',
          },]
        }
      } else {
        this.eaParams.details[0].description = "";
      }
      this.$forceUpdate();
    },
    async transformImage(data) {
      console.log("data", data);
      data.fileId = this.currentFileId;
      const res = await request({
        url: "/transformImage",
        method: "post",
        params: { data: data }
      });
      if (res.data.code > 0) {
        this.$message.error(res.data.msg);
      } else {
        if (this.currentFileType === "receipts") {
          this.eaParams.receipts.forEach((item, idx) => {
            if (item.file === this.currentFileId) {
              item.thumb_url = res.data.data.thumb_url;
              item.url = res.data.data.file_1000thumb_url;
              this.$set(this.eaParams.receipts, idx, item);
            }
            this.previewSrc = res.data.data.file_1000thumb_url;
          });
        }
        if (this.currentFileType === "details") {
          this.eaParams.details.forEach((item, idx) => {
            if (item.after_id === this.currentFileId) {
              item.after_thumb_url = res.data.data.thumb_url;
              item.after_url = res.data.data.file_1000thumb_url;
              this.$set(this.eaParams.details, idx, item);
            }
            if (item.before_id === this.currentFileId) {
              item.before_thumb_url = res.data.data.thumb_url;
              item.before_url = res.data.data.file_1000thumb_url;
              this.$set(this.eaParams.details, idx, item);
            }
          });
        }
      }
    },
    addReportTime(index) {
      this.eaParams.report_times.push({ date: "" });
      this.$forceUpdate();
    },
    deleteReportTime(index) {
      this.eaParams.report_times.splice(index, 1);
      this.$forceUpdate();
    },
    changeDate(evt, index) {
      console.log("evt......", evt);
      this.$forceUpdate();
    },
    addDetail() {
      this.eaParams["details"].push({
        description: "",
        beforeImg: "",
        afterImg: ""
      });
    },
    // 图片上传 start
    detailUpload(file) {
      const idx = file.data.index;
      const key = file.data.key;
      this.$set(this.eaParams.details, idx, {
        ...this.eaParams.details[idx],
        [key + "Loading"]: true
      });
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.$set(this.eaParams.details, idx, {
            ...this.eaParams.details[idx],
            [key + "_thumb_url"]: res.data.data.file_url_thumb,
            [key + "_id"]: res.data.data.file_id,
            [key + "_url"]: res.data.data.file_url_original,
            [key + "Loading"]: false
          });
        }
      });
    },
    receiptsUpload(file) {
      this.commonUploadImage(file).then(res => {
        console.log("res......", res);
        if (res.data.data) {
          if (typeof this.eaParams.receipts === "undefined") {
            this.eaParams.receipts = [];
          }
          this.eaParams.receipts.push({
            id: res.data.data.file_id,
            original_name: res.data.data.original_name,
            thumb_url: res.data.data.file_url_thumb,
            url: res.data.data.file_url_enough,
            file: res.data.data.id
          });
        }
      });
    },
    handleReceiptsRemove(file, fileList) {
      this.eaParams.receipts = fileList;
    },
    floorPlanUpload(file) {
      this.commonUploadImage(file).then(res => {
        console.log("res......", res);
        if (res.data.data) {
          this.floorPlans.push({
            id: res.data.data.file_id,
            original_name: res.data.data.original_name,
            thumb_url: res.data.data.file_url_thumb,
            url: res.data.data.file_url_enough,
            file: res.data.data.id
          });
        }
      });
    },
    handleFloorPlanRemove(file, fileList) {
      this.floorPlans = fileList;
    },
    equipmentUpload(file) {
      this.commonUploadImage(file).then(res => {
        console.log("res......", res);
        if (res.data.data) {
          this.equipment_pics.push({
            id: res.data.data.file_id,
            original_name: res.data.data.original_name,
            thumb_url: res.data.data.file_url_thumb,
            url: res.data.data.file_url_enough,
            file: res.data.data.id
          });
        }
      });
    },
    handleEquipmentRemove(file, fileList) {
      this.equipment_pics = fileList;
    },
    beforeImgUpload(file) {
      const isType =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isType) {
        this.$message.error("上传图片只能是 JPG|PNG 格式!");
      }
    },
    async commonUploadImage(file) {
      if (!file.file) {
        return;
      }
      let fileSuffix = "";
      if (file.file.type === "image/jpeg") {
        fileSuffix = "jpeg";
      }
      if (file.file.type === "image/png") {
        fileSuffix = "png";
      }
      if (file.file.type === "image/jpg") {
        fileSuffix = "jpg";
      }
      return getOssToken({ file_suffix: fileSuffix }).then(res => {
        if (res.data.data) {
          const ossData = res.data.data;
          const client = new OSS({
            region: "oss-" + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          });
          return client.put(ossData.file_name, file.file).then(async result => {
            if (result && result.url) {
              return getFileRealPath({ file_id: ossData.file_id });
            }
          });
        }
      });
    },
    handleCheckRemove(file, fileList, index) {
      this.eaParams.details[index].imageList = fileList;
      this.$forceUpdate();
    },
    onStart() {
      this.drag = true;
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false;
    },
    checkUpload(file, index) {
      console.log("fiel...........", file, index, this.eaParams[index]);
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          if (typeof this.eaParams.details[index].imageList === "undefined") {
            this.eaParams.details[index].imageList = [];
          }

          this.eaParams.details[index].imageList.push({
            id: res.data.data.file_id,
            url: res.data.data.file_url_original,
            name: file.file.name,
            status: "success",
            uid: res.data.data.file_id,
            thumb_url: res.data.data.file_url_thumb
          });

          this.$forceUpdate();
        }
      });
    },
    async uploadImage(file) {
      if (!file.file) {
        return;
      }
      let fileSuffix = "";
      if (file.file.type === "image/jpeg") {
        fileSuffix = "jpeg";
      }
      if (file.file.type === "image/png") {
        fileSuffix = "png";
      }
      if (file.file.type === "image/jpg") {
        fileSuffix = "jpg";
      }
      await getOssToken({ file_suffix: fileSuffix }).then(res => {
        if (res.data.data) {
          const ossData = res.data.data;
          const client = new OSS({
            region: "oss-" + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          });
          client.put(ossData.file_name, file.file).then(async result => {
            if (result && result.url) {
              this.postForm.file_ids_arr.push(ossData.file_id);
              await getFileRealPath({ file_id: ossData.file_id }).then(res => {
                if (res.data.data) {
                  this.postForm.receipts.push({
                    id: res.data.data.file_id,
                    url: res.data.data.file_url_original,
                    name: ossData.file_name
                  });
                }
              });
            }
          });
        }
      });
    },
    lookImage(ref, fileId, source, url) {
      this.previewImageSrc = url;
      this.showPictureView = true;
      this.currentFileId = fileId;
      this.currentFileType = source;
      this.$forceUpdate();
    },
    previewImage(ref, fileId, source) {
      this.$refs[ref][0].showViewer = true;
      this.currentFileId = fileId;
      this.currentFileType = source;
    },
    handleElRemove(file, fileList, index) {
      this.eaParams.elDetails[index].imageList = fileList;
      this.$forceUpdate();
    },
    handleTweRemove(file, fileList, index) {
      this.eaParams.twelveDetails[index].imageList = fileList;
      this.$forceUpdate();
    },
    handleThiRemove(file, fileList, index) {
      this.eaParams.thirteenDetails[index].imageList = fileList;
      this.$forceUpdate();
    },
    elUpload(file, index) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.eaParams.elDetails[index].imageList.push({
            id: res.data.data.file_id,
            url: res.data.data.file_url_original,
            name: file.file.name
          });
        }
      });
    },
    tweUpload(file, index) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.eaParams.twelveDetails[index].imageList.push({
            id: res.data.data.file_id,
            url: res.data.data.file_url_original,
            name: file.file.name
          });
        }
      });
    },
    thiUpload(file, index) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.eaParams.thirteenDetails[index].imageList.push({
            id: res.data.data.file_id,
            url: res.data.data.file_url_original.replace("http:", "https:"),
            name: file.file.name
          });
        }
      });
    },
    deleteImage(idx, key) {
      this.$set(this.eaParams.details, idx, {
        ...this.eaParams.details[idx],
        [key + "_thumb_url"]: "",
        [key + "_id"]: "",
        [key + "_url"]: ""
      });
    },
    upDetails(index) {
      const beforeIndex = this.eaParams.details[index - 1];
      this.eaParams.details[index - 1] = this.eaParams.details[index];
      this.eaParams.details[index] = beforeIndex;
      this.$forceUpdate();
    },
    downDetails(index) {
      const afterIndex = this.eaParams.details[index + 1];
      this.eaParams.details[index + 1] = this.eaParams.details[index];
      this.eaParams.details[index] = afterIndex;
      this.$forceUpdate();
    },
    deleteDetails(idx) {
      this.eaParams.details.splice(idx, 1);
    },
    //  图片上传 - end -
    handlePreview(file) {
      console.log("f", file);
      this.previewSrc = file.url;
      this.showViewer = true;
      this.currentFileId = file.file;
      this.currentFileType = "receipts";
    },
    async save(isPreview) {
      this.hasClick = true;
      let isCkeck = true;
      let details = [];
      console.log(this.eaParams.details);
      if (parseInt(this.eaParams.report_tid) !== 10 && parseInt(this.eaParams.report_tid) !== 13) {
        details = this.eaParams.details.map(item => {
          if (!item.description || (!item.after_id && !item.before_id)) {
            isCkeck = false;
          }
          return {
            description: item.description,
            before_id: item.before_id,
            after_id: item.after_id
          };
        });
      }
      console.log("details......", details);

      const save_data = this.eaParams;
      save_data.detail_list = [];

      if (this.maItemId) {
        save_data.ma_item_id = this.maItemId;
      }
      if (this.orderDetail && this.orderDetail.appo_task_id) {
        save_data.appo_task_id = this.orderDetail.appo_task_id;
      }
      if (this.reportId) {
        save_data.report_id = this.reportId;
      }

      if (this.orderSupplierId) {
        save_data.supplier_order_id = this.orderSupplierId;
      }

      if (this.eaParams.receipts.length > 0) {
        const receipt_ids_arr = [];
        for (const i in this.eaParams.receipts) {
          receipt_ids_arr.push(this.eaParams.receipts[i].id);
        }
        save_data.sign_ids = receipt_ids_arr.join(",");
      } else {
        save_data.sign_ids = "";
      }

      if (this.eaParams.details.length > 0) {
        for (const item in details) {
          save_data.detail_list.push({
            type: "",
            title: details[item].description,
            img_left_file_id: details[item].before_id,
            img_right_file_id:
              typeof details[item].after_id !== "undefined"
                ? details[item].after_id
                : ""
          });
        }
      }

      if (parseInt(save_data.report_tid) === 9) {
        if (this.eaParams.other_info) {
          save_data.other_info = this.eaParams.other_info;
        } else {
          save_data.other_info = {};
        }
        save_data.other_info.an_equipment_ids = "";
        for (const key in this.equipment_pics) {
          save_data.other_info.an_equipment_ids +=
            this.equipment_pics[key].id + ",";
        }
        save_data.other_info.an_equipment_ids = save_data.other_info.an_equipment_ids.substring(
          0,
          save_data.other_info.an_equipment_ids.lastIndexOf(",")
        );
        if (this.equipment_pics.length >= 1) {
          save_data.equipment_pics = this.equipment_pics;
        }
        if (this.floorPlans.length >= 1) {
          save_data.other_info.an_floor_plans_ids = "";
          for (const key in this.floorPlans) {
            save_data.other_info.an_floor_plans_ids +=
              this.floorPlans[key].id + ",";
          }
          save_data.other_info.an_floor_plans_ids = save_data.other_info.an_floor_plans_ids.substring(
            0,
            save_data.other_info.an_floor_plans_ids.lastIndexOf(",")
          );
        } else {
          save_data.other_info.an_floor_plans_ids = "";
        }
        if (this.eaParams.report_times) {
          save_data.report_at_list = [];
          for (const item in this.eaParams.report_times) {
            save_data.report_at_list.push(
              this.eaParams.report_times[item].date
            );
          }
        }
      }

      if (parseInt(save_data.report_tid) === 10) {
        if (this.eaParams.specialDetails.length < 0) {
          this.$message.error("请填写报告内容");
          return false;
        }
        for (const item in this.eaParams.specialDetails) {
          if (item === "questions") {
            for (const i in this.eaParams.specialDetails[item]) {
              if (
                this.eaParams.specialDetails[item][i].title === "" ||
                typeof this.eaParams.specialDetails[item][i].title ===
                  "undefined"
              ) {
                this.$message.error("检查问题不能为空");
                return false;
              }
              if (
                this.eaParams.specialDetails[item][i].answer === "" ||
                typeof this.eaParams.specialDetails[item][i].answer ===
                  "undefined"
              ) {
                this.$message.error("解决方案不能为空");
                return false;
              }
              save_data.detail_list.push({
                type: "questions",
                title: this.eaParams.specialDetails[item][i].title,
                answer: this.eaParams.specialDetails[item][i].answer,
                img_left_file_id: this.eaParams.specialDetails[item][i]
                  .before_id
              });
            }
          }
          if (["oneData", "twoData", "beforeAfterData"].indexOf(item) > -1) {
            for (const i in this.eaParams.specialDetails[item]) {
              if (
                this.eaParams.specialDetails[item][i].description === "" ||
                typeof this.eaParams.specialDetails[item][i].description ===
                  "undefined"
              ) {
                this.$message.error("检查问题不能为空");
                return false;
              }
              save_data.detail_list.push({
                type: item,
                title: this.eaParams.specialDetails[item][i].description,
                img_left_file_id: this.eaParams.specialDetails[item][i]
                  .before_id,
                img_right_file_id:
                  typeof this.eaParams.specialDetails[item][i].after_id !==
                  "undefined"
                    ? this.eaParams.specialDetails[item][i].after_id
                    : ""
              });
            }
          }
        }
      }

      if (parseInt(save_data.report_tid) === 11) {
        save_data.detail_list = [];
        for (const item in this.eaParams.elDetails) {
          const elDetail = {
            title: this.eaParams.elDetails[item].description,
            remark: this.eaParams.elDetails[item].remark
          };
          if (this.eaParams.elDetails[item].imageList.length < 4) {
            this.$message.error(
              this.eaParams.elDetails[item].description + "图片必须达到四张"
            );
            return false;
          }
          const imageIds = [];
          for (const i in this.eaParams.elDetails[item].imageList) {
            elDetail["img_file_id_" + i] = this.eaParams.elDetails[
              item
            ].imageList[i].id;
            imageIds.push(this.eaParams.elDetails[item].imageList[i].id);
          }
          elDetail.imageIds = imageIds.join(",");
          save_data.detail_list.push(elDetail);
        }
      }

      if (parseInt(save_data.report_tid) === 12) {
        save_data.detail_list = [];
        for (const item in this.eaParams.twelveDetails) {
          console.log(
            "item.........",
            this.eaParams.twelveDetails[item].length
          );
          const elDetail = {
            title: this.eaParams.twelveDetails[item].description,
            remark: this.eaParams.twelveDetails[item].remark
          };
          if (this.eaParams.twelveDetails[item].imageList.length < 4) {
            this.$message.error(
              this.eaParams.twelveDetails[item].description + "图片必须达到四张"
            );
            return false;
          }
          const imageIds = [];
          for (const i in this.eaParams.twelveDetails[item].imageList) {
            elDetail["img_file_id_" + i] = this.eaParams.twelveDetails[
              item
            ].imageList[i].id;
            imageIds.push(this.eaParams.twelveDetails[item].imageList[i].id);
          }
          elDetail.imageIds = imageIds.join(",");
          save_data.detail_list.push(elDetail);
        }
      }

      if (parseInt(save_data.report_tid) === 13) {
        save_data.detail_list = [];
        for (const item in this.eaParams.thirteenDetails) {
          const elDetail = {
            title: this.eaParams.thirteenDetails[item].description,
            remark: this.eaParams.thirteenDetails[item].remark,
            image_type: typeof this.eaParams.thirteenDetails[item].imageType !== 'undefined' ? this.eaParams.thirteenDetails[item].imageType : 'list'
          };

          const imageIds = [];
          for (const i in this.eaParams.thirteenDetails[item].imageList) {
            elDetail["img_file_id_" + i] = this.eaParams.thirteenDetails[
              item
            ].imageList[i].id;
            imageIds.push(this.eaParams.thirteenDetails[item].imageList[i].id);
          }
          elDetail.imageIds = imageIds.join(",");
          save_data.detail_list.push(elDetail);
        }
      }

      save_data.ma_type =
        this.eaParams.ma_type_cn === "紧急维修" ? "urgent" : "not_urgent";
      save_data.ma_item_list = [
        {
          ma_cate_id: this.eaParams.ma_cate_id,
          prob_desc: this.eaParams.report_title,
          location: "",
          file_ids: "",
          appo_task_list: [
            {
              ma_end_at: "",
              submit_remark: "",
              ma_start_at: "",
              worker_ids: "" // this.eaParams.workers.join(',')
            }
          ]
        }
      ];
      save_data.ma_remark = this.eaParams.report_title;
      const result = await createOrderAndReport(save_data);
      if (result.data.code > 0) {
        this.$message.error(result.data.msg);
      } else {
        if (isPreview) {
          let report_title =
            this.commonDetails.brand_en +
            "-" +
            this.commonDetails.store_cn +
            save_data.report_title +
            dayjs().format("YYYYMMDD");
          if (this.eaParams.completed_at) {
            report_title =
              this.commonDetails.brand_en +
              "-" +
              this.commonDetails.store_cn +
              save_data.report_title +
              this.eaParams.completed_at;
          }
          if (this.reportId) {
            window.open(
              "#/report_pdf?report_id=" +
                this.reportId +
                "&report_title=" +
                report_title,
              "_blank"
            );
          } else {
            window.open(
              "#/report_pdf?report_id=" +
                result.data.data +
                "&report_title=" +
                report_title,
              "_blank"
            );
          }
          return;
        }
        this.$message.success("操作成功");
        this.$emit("hideDetail", null);
        this.$emit("refresh", null);
      }
    },
    back() {
      this.$emit("hideDetail", null);
    },
    closeLookViewer() {
      this.showPictureView = false;
    },
    closeViewer() {
      this.showViewer = false;
    },
    cleanAirMachineUpload(file, index, type) {
      fileUpload("/uploadImg", file, { source: "report" }).then(res => {
        if (res.code === 20000) {
          if (res.data.code > 0) {
            this.$message.error(res.data.msg);
          } else {
            if (type === "before") {
              this.eaParams.specialDetails.cleanAirMachine[
                index
              ].before_thumb_url = res.data.data.thumb_url;
              this.eaParams.specialDetails.cleanAirMachine[index].before_url =
                res.data.data.url;
              this.eaParams.specialDetails.cleanAirMachine[index].before_id =
                res.data.data.id;
              this.eaParams.specialDetails.cleanAirMachine[
                index
              ].before_original_name = res.data.data.original_name;
            }
            if (type === "after") {
              this.eaParams.specialDetails.cleanAirMachine[
                index
              ].after_thumb_url = res.data.data.thumb_url;
              this.eaParams.specialDetails.cleanAirMachine[index].after_url =
                res.data.data.url;
              this.eaParams.specialDetails.cleanAirMachine[index].after_id =
                res.data.data.id;
              this.eaParams.specialDetails.cleanAirMachine[
                index
              ].after_original_name = res.data.data.original_name;
            }
            this.receiptsLoading = false;
            this.$forceUpdate();
          }
        }
      });
    },
    deleteCleanAirMachineBeforeImage(idx, key) {},
    deleteCleanAirMachineAfterImage(idx, key) {},
    addColumn(type, index) {
      this.eaParams.specialDetails[type].push({ description: "" });
      this.$forceUpdate();
    },
    deleteColumn(type, index) {
      this.eaParams.specialDetails[type].splice(index, 1);
    },
    deleteSpecialTwoImageUpload(index, type) {
      if (type === "before") {
        this.eaParams.specialDetails.twoData[index].before_thumb_url = "";
        this.eaParams.specialDetails.twoData[index].before_url = "";
        this.eaParams.specialDetails.twoData[index].before_id = "";
        this.eaParams.specialDetails.twoData[index].before_original_name = "";
      }
      if (type === "after") {
        this.eaParams.specialDetails.twoData[index].after_thumb_url = "";
        this.eaParams.specialDetails.twoData[index].after_url = "";
        this.eaParams.specialDetails.twoData[index].after_id = "";
        this.eaParams.specialDetails.twoData[index].after_original_name = "";
      }
      this.$forceUpdate();
    },
    deleteSpecialBeforeAfterImage(index, type) {
      if (type === "before") {
        this.eaParams.specialDetails.beforeAfterData[index].before_thumb_url =
          "";
        this.eaParams.specialDetails.beforeAfterData[index].before_url = "";
        this.eaParams.specialDetails.beforeAfterData[index].before_id = "";
        this.eaParams.specialDetails.beforeAfterData[
          index
        ].before_original_name = "";
      }
      if (type === "after") {
        this.eaParams.specialDetails.beforeAfterData[index].after_thumb_url =
          "";
        this.eaParams.specialDetails.beforeAfterData[index].after_url = "";
        this.eaParams.specialDetails.beforeAfterData[index].after_id = "";
        this.eaParams.specialDetails.beforeAfterData[
          index
        ].after_original_name = "";
      }
      this.$forceUpdate();
    },
    specialOneImageUpload(file, index) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.eaParams.specialDetails.oneData[index].before_thumb_url =
            res.data.data.file_url_thumb;
          this.eaParams.specialDetails.oneData[index].before_url =
            res.data.data.file_url_original;
          this.eaParams.specialDetails.oneData[index].before_id =
            res.data.data.file_id;
          this.receiptsLoading = false;
          this.$forceUpdate();
        }
      });
    },
    deleteSpecialOneImageUpload(index) {
      this.eaParams.specialDetails.oneData[index].before_thumb_url = "";
      this.eaParams.specialDetails.oneData[index].before_url = "";
      this.eaParams.specialDetails.oneData[index].before_id = "";
      this.eaParams.specialDetails.oneData[index].before_original_name = "";
      this.$forceUpdate();
    },
    specialTwoImageUpload(file, index, type) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          if (type === "before") {
            this.eaParams.specialDetails.twoData[index].before_thumb_url =
              res.data.data.file_url_thumb;
            this.eaParams.specialDetails.twoData[index].before_url =
              res.data.data.file_url_original;
            this.eaParams.specialDetails.twoData[index].before_id =
              res.data.data.file_id;
          }
          if (type === "after") {
            this.eaParams.specialDetails.twoData[index].after_thumb_url =
              res.data.data.file_url_thumb;
            this.eaParams.specialDetails.twoData[index].after_url =
              res.data.data.file_url_original;
            this.eaParams.specialDetails.twoData[index].after_id =
              res.data.data.file_id;
          }
          this.receiptsLoading = false;
          this.$forceUpdate();
        }
      });
    },
    specialBeforeAfterImageUpload(file, index, type) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          if (type === "before") {
            this.eaParams.specialDetails.beforeAfterData[
              index
            ].before_thumb_url = res.data.data.file_url_thumb;
            this.eaParams.specialDetails.beforeAfterData[index].before_url =
              res.data.data.file_url_original;
            this.eaParams.specialDetails.beforeAfterData[index].before_id =
              res.data.data.file_id;
          }
          if (type === "after") {
            this.eaParams.specialDetails.beforeAfterData[
              index
            ].after_thumb_url = res.data.data.file_url_thumb;
            this.eaParams.specialDetails.beforeAfterData[index].after_url =
              res.data.data.file_url_original;
            this.eaParams.specialDetails.beforeAfterData[index].after_id =
              res.data.data.file_id;
          }
          this.receiptsLoading = false;
          this.$forceUpdate();
        }
      });
    },
    machineRepairUpload(file_type, file, type) {
      fileUpload("/uploadImg", file, { source: "report" }).then(res => {
        if (res.code === 20000) {
          if (res.data.code > 0) {
            this.$message.error(res.data.msg);
          } else {
            if (type === "before") {
              this.eaParams.specialDetails[file_type].before_thumb_url =
                res.data.data.thumb_url;
              this.eaParams.specialDetails[file_type].before_url =
                res.data.data.url;
              this.eaParams.specialDetails[file_type].before_id =
                res.data.data.id;
              this.eaParams.specialDetails[file_type].before_original_name =
                res.data.data.original_name;
            }
            if (type === "after") {
              this.eaParams.specialDetails[file_type].after_thumb_url =
                res.data.data.thumb_url;
              this.eaParams.specialDetails[file_type].after_url =
                res.data.data.url;
              this.eaParams.specialDetails[file_type].after_id =
                res.data.data.id;
              this.eaParams.specialDetails[file_type].after_original_name =
                res.data.data.original_name;
            }
            this.receiptsLoading = false;
            this.$forceUpdate();
          }
        }
      });
    },
    deleteRepairImage(image_type, type) {
      if (type === "before") {
        this.eaParams.specialDetails[image_type].before_thumb_url = "";
        this.eaParams.specialDetails[image_type].before_url = "";
        this.eaParams.specialDetails[image_type].before_id = "";
        this.eaParams.specialDetails[image_type].before_original_name = "";
      }
      if (type === "after") {
        this.eaParams.specialDetails[image_type].after_thumb_url = "";
        this.eaParams.specialDetails[image_type].after_url = "";
        this.eaParams.specialDetails[image_type].after_id = "";
        this.eaParams.specialDetails[image_type].after_original_name = "";
      }
      this.$forceUpdate();
    },
    questionImagesUpload(file, index) {
      this.commonUploadImage(file).then(res => {
        if (res.data.data) {
          this.eaParams.specialDetails.questions[index].before_thumb_url =
            res.data.data.file_url_thumb;
          this.eaParams.specialDetails.questions[index].before_url =
            res.data.data.file_url_original;
          this.eaParams.specialDetails.questions[index].before_id =
            res.data.data.file_id;
          this.receiptsLoading = false;
          this.$forceUpdate();
        }
      });
    },
    checkImagesUpload(file) {
      fileUpload("/uploadImg", file, { source: "report" }).then(res => {
        if (res.code !== 20000 || res.data.code > 0) {
          this.$message.error(res.data.msg);
          return false;
        }
        this.eaParams.specialDetails.checkImages.push({
          id: 0,
          deg: 0,
          original_name: res.data.data.original_name,
          thumb_url: res.data.data.thumb_url,
          url: res.data.data.url,
          file: res.data.data.id
        });
        console.log(this.eaParams.specialDetails.checkImages);
        this.receiptsLoading = false;
        this.$forceUpdate();
      });
    },
    handleCheckImagesRemove(file, fileList) {
      this.eaParams.specialDetails.checkImages = fileList;
    },
    deleteQuestionImage(index) {
      this.eaParams.specialDetails.questions[index].images = {};
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="less">
.report-detail {
  padding: 20px;

  h3 {
    margin-bottom: 20px;
  }

  .el-select,
  .el-date-editor {
    width: 100%;
  }
  .receipts {
    border: 1px dotted #dddfe6;
    margin-bottom: 20px;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-image {
      width: 200px;
      height: 200px;
      border: 1px solid #c0ccda;
      border-radius: 4px;
    }
  }
  .detail-items {
    border: 1px dotted #dddfe6;
    margin-bottom: 20px;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    .detail-items-top {
      display: flex;
      justify-content: space-between;
      .detail-list {
        width: 150px;
        min-width: 150px;
        height: 150px;
        display: flex;
        flex-direction: column;
        .detail-title {
          font-size: 14px;
          color: #333;
          line-height: 40px;
          height: 40px;
          font-weight: 600;
          text-align: center;
        }
        .upload-container {
          flex: 1;
          overflow: hidden;
        }
      }
      .el-upload {
        position: relative !important;
        height: 146px;
        display: flex;
        align-items: center;
        justify-content: center;
        .modal {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            color: #fff;
            font-size: 16px;
            display: none;
            margin: 0 4px;
          }

          &:hover {
            background: rgba(0, 0, 0, 0.5);
            i {
              display: inline-block;
            }
          }
        }
      }
    }
    .detail-info {
      width: 100%;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      textarea {
        resize: none !important;
      }
    }
  }
}

.is-save-error {
  input,
  textarea,
  .el-upload {
    border-color: #f56c6c;
  }
  input:hover,
  textarea:hover {
    border-color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/new-report-pc.vue